import { IComponentOptions, IController } from 'angular';
import { ICropOptions } from './shared/crop-options';
import { ICropImageModalData } from './shared/crop-image-modal-data.interface';
import { CropImageService } from './services/crop-image.service';
import { ToastrService } from '../../../core/services/toastr/toastr.service';
import './crop-image-modal.component.scss';

class CropImageModalCtrl implements IController {
  static $inject = [
    'CropImageService',
    'ToastrService'
  ];
  onClose: ( data: { result: ICropImageModalData } ) => void;
  data: ICropImageModalData;
  inputImage;
  resultImage = '';
  cropOptions: ICropOptions = {
    areaType: 'square'
  };
  private DEFAULT_CONVERT_ERROR = 'Picture convert error';

  constructor( private cropImageService: CropImageService,
               private toastrService: ToastrService ) {
  }

  $onInit() {
    const { file } = this.data;
    if ( !file ) {
      return this.closeModal(null);
    }
    this.convertFileToDataURI(file);
  }

  closeModal( result ) {
    this.onClose({ result });
  }

  onOkClick() {
    if ( !this.resultImage ) {
      return;
    }
    const filename = this.data.file.name;
    this.cropImageService.convertDataURIToFile(this.resultImage, filename)
      .then(( file ) => {
        this.closeModal(file);
      })
      .catch(( err ) => {
        console.log(err);
        const errMessage = err instanceof Error ? err.message : this.DEFAULT_CONVERT_ERROR;
        this.toastrService.error(errMessage, 'Error');
        this.closeModal(null);
      });
  }

  private convertFileToDataURI( file: File ) {
    if ( !file ) {
      return;
    }
    this.cropImageService.convertFileToDataURI(file)
      .then(( data ) => {
        this.inputImage = data;
      })
      .catch(( err ) => {
        console.log(err);
        const errMessage = err instanceof Error ? err.message : this.DEFAULT_CONVERT_ERROR;
        this.toastrService.error(errMessage, 'Error');
        this.closeModal(null);
      });
  }
}

export const CropImageModalComponent: IComponentOptions = {
  controller: CropImageModalCtrl,
  template: require('./crop-image-modal.component.html'),
  bindings: {
    onClose: '&',
    data: '<'
  }
};



// WEBPACK FOOTER //
// ./app/components/modals/crop-image-modal/crop-image-modal.component.ts